<section>
    <h1>See if MVP CTO is a perfect fit <handwritten-text>(we think it will be)</handwritten-text></h1>
    <h3><p>Let's chat to discuss your project and walk you through the MVP CTO process and offerings.</p></h3>
</section>